import { Navigate } from 'react-router-dom';
import { Page, type DispatchedAction } from '@eo/shared';

import { useAppSelector } from '../../app/store';
import { UserDetailContent } from './UserDetailContent';
import { userDetailController } from './controller';
import type { UserDetailState } from './types';

// Capacity configuration is admin-only on every route it touches; the gate here
// is UX, and the backend re-checks on each one.
export default function UserDetailPage() {
  const me = useAppSelector((s) => s.staff.me);
  if (!me?.isAdmin) return <Navigate to="/" replace />;

  return (
    <Page<UserDetailState> controller={userDetailController as never}>
      {({ data, actions }) => (
        <UserDetailContent
          data={data}
          onUpsertSplit={(payload) => actions.upsertSplit(payload) as Promise<DispatchedAction>}
          onCreateTimeOff={(payload) => actions.createTimeOff(payload) as Promise<DispatchedAction>}
          onRemoveTimeOff={(payload) => actions.removeTimeOff(payload) as Promise<DispatchedAction>}
          onSetClientOwner={(payload) =>
            actions.setClientOwner(payload) as Promise<DispatchedAction>
          }
          onQueryOptions={(payload) => void actions.queryOptions(payload)}
        />
      )}
    </Page>
  );
}
